export default {
  admin: () => import("D:/APPS/mayoschic/layouts/admin.vue").then(m => m.default || m),
  default: () => import("D:/APPS/mayoschic/layouts/default.vue").then(m => m.default || m),
  login: () => import("D:/APPS/mayoschic/layouts/login.vue").then(m => m.default || m)
}